import axios from "axios";
import { API_BASE, buildAuthHeaders } from "./base";

const API = API_BASE;

const clientAuthHeaders = (token) => ({
  "Content-Type": "application/json",
  ...buildAuthHeaders(token),
});

export async function getPublicSettings(salonId) {
  const res = await axios.get(
    `${API}/client-portal/salons/${salonId}/public-settings`
  );
  return res.data;
}

export async function registerClient(salonId, payload) {
  const res = await axios.post(
    `${API}/client-portal/salons/${salonId}/register`,
    payload,
    { headers: clientAuthHeaders() }
  );
  return res.data;
}

export async function validateCredentialSetup(token, salonId) {
  const res = await axios.get(`${API}/client-portal/credential-setup/validate`, {
    params: { token, salon_id: salonId },
    headers: clientAuthHeaders(),
  });
  return res.data;
}

export async function completeCredentialSetup(payload) {
  const res = await axios.post(
    `${API}/client-portal/credential-setup/complete`,
    payload,
    { headers: clientAuthHeaders() }
  );
  return res.data;
}

export async function requestPasswordReset(salonId, identifier) {
  const res = await axios.post(
    `${API}/client-portal/salons/${salonId}/password-reset/request`,
    { identifier },
    { headers: clientAuthHeaders() }
  );
  return res.data;
}

export async function validatePasswordReset(token, salonId) {
  const res = await axios.get(`${API}/client-portal/password-reset/validate`, {
    params: { token, salon_id: salonId },
    headers: clientAuthHeaders(),
  });
  return res.data;
}

export async function completePasswordReset(payload) {
  const res = await axios.post(
    `${API}/client-portal/password-reset/complete`,
    payload,
    { headers: clientAuthHeaders() }
  );
  return res.data;
}

export async function loginClient(salonId, payload) {
  const res = await axios.post(
    `${API}/client-portal/salons/${salonId}/login`,
    payload,
    { headers: clientAuthHeaders(), withCredentials: true }
  );
  return res.data;
}

export async function getMe(token) {
  const res = await axios.get(`${API}/client-portal/me`, {
    headers: clientAuthHeaders(token),
    withCredentials: true,
  });
  return res.data;
}

export async function updateMe(payload, token) {
  const res = await axios.put(`${API}/client-portal/me`, payload, {
    headers: clientAuthHeaders(token),
    withCredentials: true,
  });
  return res.data;
}

export async function getPortalRewards(token) {
  const res = await axios.get(`${API}/client-portal/rewards`, {
    headers: clientAuthHeaders(token),
    withCredentials: true,
  });
  return res.data;
}

export async function getPortalRewardsTransactions(token, params = {}) {
  const res = await axios.get(`${API}/client-portal/rewards/transactions`, {
    params,
    headers: clientAuthHeaders(token),
    withCredentials: true,
  });
  return res.data;
}

export async function getPortalGiftCards(token) {
  const res = await axios.get(`${API}/client-portal/gift-cards`, {
    headers: clientAuthHeaders(token),
    withCredentials: true,
  });
  return res.data;
}

export async function getClientPortalSession() {
  const res = await axios.get(`${API}/client-portal/session`, {
    withCredentials: true,
    validateStatus: (status) => status === 200 || status === 401,
  });
  return res.status === 401 ? null : res.data;
}

export async function logoutClientPortal() {
  const res = await axios.post(
    `${API}/client-portal/logout`,
    {},
    {
      withCredentials: true,
      validateStatus: (status) => status === 200 || status === 401,
    }
  );
  return res.status === 401 ? { ok: true } : res.data;
}
